const Spinner = ({ className = "" }) => (
  <svg
    className={`animate-spin h-5 w-5 ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
    />
  </svg>
);

const VARIANTS = {
  primary:
    "bg-primary-500 text-white hover:bg-primary-600 disabled:bg-primary-300",
  secondary:
    "bg-white text-primary-500 border border-primary-500 hover:bg-primary-50 disabled:opacity-50",
  success:
    "bg-green-600 text-white hover:bg-green-700 disabled:bg-green-300",
  danger:
    "bg-red-500 text-white hover:bg-red-600 disabled:bg-red-300",
};

const SIZES = {
  sm: "px-4 py-1.5 text-xs",
  md: "px-6 py-2.5 text-sm",
  lg: "px-8 py-3 text-base",
};

const Button = ({
  children,
  loading = false,
  variant = "primary",
  size = "md",
  fullWidth = false,
  disabled = false,
  className = "",
  ...props
}) => {
  return (
    <button
      disabled={disabled || loading}
      className={`
        inline-flex items-center justify-center gap-2 rounded-md font-medium
        transition cursor-pointer disabled:cursor-not-allowed
        ${VARIANTS[variant]}
        ${SIZES[size]}
        ${fullWidth ? "w-full" : ""}
        ${className}
      `}
      {...props}
    >
      {loading && <Spinner className="text-current" />}
      {children}
    </button>
  );
};

export default Button;
